var _style, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomarcaBloomBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 855.6 263.2",
    style: {
      enableBackground: "new 0 0 855.6 263.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.4,149.1c0-19.3-13.1-33.1-32.8-33.1c-19.5,0-32.6,13.9-32.6,33.1c0,19.3,13.1,33.1,32.6,33.1 C367.2,182.3,380.4,168.4,380.4,149.1 M296.7,148.4V59.9c10.1,0,18.3,8.2,18.3,18.3v40.1C322,106,335.1,99,350.5,99 c24.9,0,48.4,17.9,48.4,49.5c0,29.9-21.2,50.7-51.5,50.7C317.9,199.2,296.7,179.4,296.7,148.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 417.3,
    y: 59.9,
    className: "st0",
    width: 18.3,
    height: 136.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.2,149.1c0-19.3-13.1-33.1-32.8-33.1c-19.7,0-32.8,13.9-32.8,33.1c0,19.3,13.1,33.1,32.8,33.1 C525.1,182.3,538.2,168.4,538.2,149.1 M454.2,149.1c0-28.9,21.2-50.1,51.3-50.1c30.1,0,51.3,21.2,51.3,50.1 c0,28.9-21.2,50.1-51.3,50.1C475.4,199.2,454.2,178,454.2,149.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.9,149.1c0-19.3-13.1-33.1-32.8-33.1c-19.7,0-32.8,13.9-32.8,33.1c0,19.3,13.1,33.1,32.8,33.1 C638.8,182.3,651.9,168.4,651.9,149.1 M567.9,149.1c0-28.9,21.2-50.1,51.3-50.1c30.1,0,51.3,21.2,51.3,50.1 c0,28.9-21.2,50.1-51.3,50.1C589.1,199.2,567.9,178,567.9,149.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.4,141.6c0-29.1,17-42.6,39.3-42.6c14.6,0,27,6.6,33.5,18.9C764.8,105.6,777,99,791.8,99 c22.4,0,39.3,13.5,39.3,42.6v55.1h-18.3v-55.1c0-17.7-9.4-25.6-22.7-25.6c-12.9,0-22.5,8.3-22.5,25.6v55.1h-18.3v-55.1 c0-17.3-9.8-25.6-22.7-25.6c-13.3,0-22.7,7.9-22.7,25.6v55.1h-18.3V141.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,12.7c-30.2,0-54.7,24.5-54.7,54.7c0,30.2,24.5,54.7,54.7,54.7l21.2-0.2c0.2,0,0.4,0,0.5,0l4.1,0 c0.2,0,0.4,0,0.6,0l2.4,0.2c2.6,0.3,5.2,0.8,7.7,1.5l0,0c4.4,1.2,8.6,3.1,12.4,5.5c0.4,0.2,0.7,0.5,1,0.8c1.5,1,2.9,2,4.2,3.2 c0.8,0.7,1.6,1.5,2.3,2.3c0.8,0.8,1.6,1.5,2.3,2.3c1.2,1.3,2.2,2.8,3.2,4.2c0.2,0.4,0.5,0.7,0.8,1c2.4,3.8,4.3,7.9,5.5,12.4l0,0 c0.7,2.5,1.2,5,1.5,7.7l0.2,2.4c0,0.2,0,0.4,0,0.6l0,4.1c0,0.1,0,0.3,0,0.5l-0.2,21.2c0,30.2,24.4,54.7,54.6,54.7h0.1 c30.2,0,54.7-24.5,54.7-54.7c0-30.2-24.5-54.7-54.7-54.7l-21.4,0c-0.4,0-0.8,0-1.2,0h-2.4c-0.4,0-0.8,0-1.2,0l-2.3-0.2 c-2.6-0.3-5.2-0.8-7.7-1.5l0,0c-4.5-1.2-8.6-3.1-12.4-5.5c-0.3-0.2-0.5-0.4-0.8-0.6c-1.6-1-3.1-2.2-4.5-3.4 c-0.8-0.7-1.6-1.5-2.3-2.3c-0.8-0.8-1.6-1.5-2.3-2.3c-1.2-1.4-2.3-2.9-3.4-4.5c-0.2-0.3-0.4-0.5-0.6-0.8c-2.4-3.8-4.3-8-5.5-12.4 l0,0c-0.7-2.5-1.2-5-1.5-7.7l-0.2-2.3c0-0.4,0-0.8,0-1.2l0-2.4c0-0.4,0-0.8,0-1.2l0-21.4C130.8,37.2,106.4,12.7,76.1,12.7 C76.2,12.7,76.2,12.7,76.1,12.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.5,37c-17.5,17.5-17.5,45.9,0,63.5c17.5,17.5,45.9,17.5,63.5,0c17.5-17.5,17.5-45.9,0-63.5 c-8.8-8.8-20.2-13.1-31.7-13.1C187.7,23.8,176.2,28.2,167.5,37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,158.7c-17.5,17.5-17.5,45.9,0,63.5s45.9,17.5,63.5,0c17.5-17.5,17.5-45.9,0-63.5 c-8.8-8.8-20.2-13.1-31.7-13.1C66,145.5,54.5,149.9,45.7,158.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarcaBloomBranco);
export default __webpack_public_path__ + "static/media/Logomarca_Bloom_Branco.dd9ac639277e4aa6dea3af7cc350550b.svg";
export { ForwardRef as ReactComponent };